import { FreightPricingPortalError } from "@/types/error/FreightPricingPortalError";
import { ApolloError } from "@apollo/client";
import { isDefined } from "@/lib/IsDefined";

export const transformApolloErrorToFreightPricingPortalErrors = (
  apolloError: ApolloError
): Array<FreightPricingPortalError> => {
  return apolloError.graphQLErrors
    .map<FreightPricingPortalError>((gqlError) => {
      return {
        errors: [
          {
            message: gqlError.message,
            path: gqlError.path ? gqlError.toString() : undefined,
          },
        ],
        message: apolloError.message,
      };
    })
    .filter(isDefined);
};
